export default __webpack_public_path__ + "989d5c3e2102565e488e548b0ad812eb.jpg";